
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getBrands",
      resolverType: "query",
      routePath: "/getBrands",
      httpMethod: "POST",
    });
  